<template>
  <div class='coursework-viewer__slide'>
    <img class='js-coursework-view__img' @load="ready" v-bind:src="mediaUrl" v-bind:class="{'coursework-viewer__grid-pattern': (media.extension === '.png')}">
  </div>
</template>

<script>
  export default {
    props: {
      media: Object
    },
    computed: {
      mediaUrl() {
        return this.media.file.gallery && this.media.file.gallery.url || this.media.file.url
      }
    },
    methods: {
      ready() {
        this.$emit('ready', this.media.id)
      }
    },
    created() {
      this.$parent.slides.push(this);
    },
    mounted() {

    }
  }
</script>
